module.exports = __webpack_public_path__ + "img/aaron.aded4533.png";